
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const TermsConditions = () => {
    const [loader, setLoader] = useState(false)
    const [cmsDetails, setCmsDetails] = useState({});

    useEffect(() => {
        setLoader(true)
        cmsDetailsAction({ slug: "terms-conditions" }, (response) => {
            if (response?.status === true) {
                setCmsDetails(response?.data)
            }
            setLoader(false)
        })();
    }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Terms and Conditions
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className="cms_content_text">
                        <p>
                            These Terms and Conditions ("Terms") govern your access to and use of the Millionaire11 platform, a real-money fantasy sports gaming service operated by Millionaire11 Fantasy Sports Private Limited, registered under the laws of India. By registering on Millionaire11, you acknowledge that you have read, understood, and agree to be bound by these legally binding Terms, which are subject to revision at any time without prior notice. Continued use of the platform indicates your acceptance of any revised Terms. 
                        </p>

                        <br />

                        <p>
                            Millionaire11 provides a fantasy sports experience where users, based on their knowledge of cricket, create virtual teams comprising real-life players participating in real-world matches. These teams compete in contests for points based on actual player performances. Our platform strictly adheres to the laws regarding games of skill and does not constitute gambling, betting, or wagering under applicable Indian laws. However, you must be a resident of India (excluding states like Assam, Odisha, Telangana, Andhra Pradesh, Nagaland, and Sikkim where real-money skill games are restricted), at least 18 years of age, and legally competent to enter into a binding agreement to participate in any paid contests.
                        </p>

                        <br />

                        <p>
                            You agree not to create multiple accounts, use unauthorized means to access the platform, exploit software bugs, or use automated bots or cheats. Violations of fair play will result in account suspension and forfeiture of winnings. All deposits are voluntary and must come from your own bank account or payment wallet. You also understand that winning is based solely on the skill of selecting and managing fantasy teams and not on chance or luck. 
                        </p>

                        <br />

                        <p>
                            The entry fee for each contest and the applicable winnings are displayed transparently. The company reserves the right to modify or cancel contests, correct errors in points, and withhold winnings in cases of suspicious activity. Taxes, including TDS (as per section 194BA), may be deducted at source as per prevailing laws, and the user is solely responsible for complying with their local tax obligations. PAN verification is mandatory for any withdrawals exceeding legal thresholds. 
                        </p>

                        <br />

                        <p>
                            All intellectual property, including logos, designs, and algorithms used on Millionaire11, remain the sole property of the company. You are granted a limited, non-exclusive license to use the platform solely for personal, non-commercial purposes.
                        </p>

                        <br/>

                        <p>
                            These Terms are governed by the laws of India. All disputes, controversies, or claims shall be subject to the exclusive jurisdiction of the competent courts of Delhi, India. You may not assign or transfer your rights under these Terms to any third party.
                        </p>

                        <br />

                        <p>
                            For any concerns, grievances, or legal notices, please reach out via our Help & Support section.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TermsConditions